import { ComponentChildren, h } from 'preact'

interface Props {
    message: ComponentChildren
}

const Tip = ({ message }: Props) => <div className='tip-box'> { message } </div>

export default Tip
